import { Link } from '@inertiajs/react';
import clsx from 'clsx';
import React from 'react';

interface GlassCardProps {
    as?: 'div' | 'button' | 'link';
    href?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
    className?: string;
    children: React.ReactNode;
    style?: React.CSSProperties;
    onMouseEnter?: React.MouseEventHandler<HTMLElement>;
    onMouseLeave?: React.MouseEventHandler<HTMLElement>;
}

const baseClass =
    'rounded-xl border border-white/50 bg-white/30 backdrop-blur-sm transition-all duration-200 dark:border-white/10 dark:bg-white/10 [box-shadow:0_3px_10px_rgba(0,0,0,0.22),0_1px_4px_rgba(0,0,0,0.15)]';

const interactiveClass = 'cursor-pointer hover:bg-white/40 hover:shadow-xl';

const GlassCard: React.FC<GlassCardProps> = ({
    as = 'div',
    href,
    onClick,
    className,
    children,
    style,
    onMouseEnter,
    onMouseLeave,
}) => {
    const combined = clsx(baseClass, as !== 'div' && interactiveClass, className);

    if (as === 'link') {
        return (
            <Link
                href={href || ''}
                className={combined}
                style={style}
                onMouseEnter={onMouseEnter as React.MouseEventHandler<HTMLAnchorElement>}
                onMouseLeave={onMouseLeave as React.MouseEventHandler<HTMLAnchorElement>}
            >
                {children}
            </Link>
        );
    }

    if (as === 'button') {
        return (
            <button
                type="button"
                onClick={onClick as React.MouseEventHandler<HTMLButtonElement>}
                className={combined}
                style={style}
                onMouseEnter={onMouseEnter as React.MouseEventHandler<HTMLButtonElement>}
                onMouseLeave={onMouseLeave as React.MouseEventHandler<HTMLButtonElement>}
            >
                {children}
            </button>
        );
    }

    return (
        <div
            className={combined}
            style={style}
            onClick={onClick as React.MouseEventHandler<HTMLDivElement>}
            onMouseEnter={onMouseEnter as React.MouseEventHandler<HTMLDivElement>}
            onMouseLeave={onMouseLeave as React.MouseEventHandler<HTMLDivElement>}
        >
            {children}
        </div>
    );
};

export default GlassCard;
